import React, { useEffect, useState } from 'react';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import Layout from './Layout';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setAddOtherBeneficiary, setAdditionalData, setBeneficiaryData, setCurrentTab, setDeleteBeneficiaryData, setEditBeneficiaries, setGlobalTab, setTypeBeneficiary } from '../redux/reducer/stepReducer/stepReducer';
import { useSelector } from 'react-redux';
import { relation } from '../utilities';
import { Fade, Modal } from '@mui/material';

const customStyles = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '287px',
    bgcolor: '#ECE6F0',
    borderRadius: '20px',
    p: '16px',
};

const SuccessBenData = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const data = useSelector(state => state.adminReducer.login);
    const beneficiaryData = useSelector((state) => state.firstStep.beneficiaryData);
    const [modalIs, setModalIs] = useState(false);
    const [savedIndex, setSavedIndex] = useState('');


    const onNextPage = () => {
        dispatch(setCurrentTab(3));
        navigate("/pago");
    };


    const handleDeleteBeneficiary = () => {
        setModalIs(false);
        dispatch(setDeleteBeneficiaryData(savedIndex));
        dispatch(setEditBeneficiaries(true));
        navigate('/datosBeneficiario');
    };

    const handleCancelModal = () => {
        setSavedIndex('');
        setModalIs(false);
    }

    const handleModalIS = (index) => {
        setSavedIndex(index);
        setModalIs(true);
    };

    const handleBackButton = () => {
        // dispatch(setEditBeneficiaries(true));
        dispatch(setTypeBeneficiary('other'));
        navigate('/datosBeneficiario');
    };

    const handleEditBeneficiaryData = (add) => {
        // navigate(`/beneficiaryData?onEdit=true&index=${index}`);
        // dispatch(setEditBeneficiaries(true));
        navigate('/datosBeneficiario');
    };

    const handleAddBeneficiaryData = () => {
        dispatch(setBeneficiaryData([{
            family: '',
            dni: '',
            name: '',
            lastname: '',
            birthday: '',
            email: '',
            area: '',
            phone: '',
            percent: '',
            order: '',
        }]));
        dispatch(setTypeBeneficiary('other'));
        navigate('/datosBeneficiario');
    };

    useEffect(() => {
        dispatch(setEditBeneficiaries(false));
        dispatch(setAddOtherBeneficiary(false));
    }, []);

    useEffect(() => {
        dispatch(setAdditionalData('Datos de beneficiario'));
        dispatch(setGlobalTab(2.6));

        return () => {
            dispatch(setAdditionalData(''));
        };
    }, [])

    return (
        <Layout>
            <div style={{ marginTop: "24px" }}>

                <Stack direction={"row"} display={"flex"} justifyContent={"center"} marginBottom={'10px'} >
                    <p>Ingresá los datos de beneficiario</p>
                </Stack>

                {
                    beneficiaryData?.map((item, index) => (
                        <Card
                            key={index}
                            sx={{
                                maxWidth: 330,
                                minWidth: 200,
                                borderRadius: '8px',
                                marginBottom: '12px',
                                marginRight: '12px',
                                marginLeft: '12px',
                                paddingLeft: '5px',
                                paddingRight: '25px'
                            }}
                        >
                            <CardContent sx={{ width: 330, height: 125, color: '#181a19', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                                    <Typography gutterBottom variant="h6" component="div" style={{ fontFamily: 'Roboto' }}>
                                        {item.name} {item.lastname}
                                    </Typography>
                                    <Typography
                                        gutterBottom
                                        variant="body"
                                        component="div"
                                        style={{ fontFamily: 'Roboto' }}
                                    >
                                        {relation.find((e) => e.value == item.family)?.label} | {item.dni}
                                    </Typography>
                                </Box>
                                <Box>
                                    <Stack spacing={1} direction="row" alignItems={'flex-end'}>
                                        <Button

                                            style={{ borderRadius: 20, textTransform: 'capitalize' }}
                                            size="medium"
                                            color="secondary"
                                            startIcon={<DeleteIcon />}
                                            onClick={() => handleModalIS(index)}
                                        >Borrar</Button>
                                        <Button style={{ borderRadius: 20, textTransform: 'capitalize' }} size="medium" color="secondary" startIcon={<EditIcon />}
                                            onClick={handleEditBeneficiaryData}
                                        >Editar</Button>
                                    </Stack>
                                </Box>
                            </CardContent>
                        </Card>
                    ))}
                <Stack direction="row" display={"flex"} justifyContent={"end"} alignItems={"center"} marginTop={'24px'}>
                    <Button
                        style={{ borderRadius: 20, textTransform: 'capitalize', marginTop: 12, marginRight: 15 }}
                        size="small"
                        color="secondary"
                        variant="outlined"
                        onClick={handleAddBeneficiaryData}
                    >
                        + Añadir beneficiario
                    </Button>
                </Stack>
                < div className='contenedorBotones' >
                    <Stack spacing={1} direction="row" alignItems={'flex-end'}>
                        <Button style={{ borderRadius: 20, textTransform: 'capitalize' }} size="medium" color="secondary" variant="outlined" onClick={handleBackButton}>Atrás</Button>
                        <Button style={{ borderRadius: 20, textTransform: 'capitalize' }} size="medium" color="secondary" variant="contained" type='submit' onClick={onNextPage}>Continuar</Button>
                    </Stack>
                </div >
            </div>
            <Modal
                open={modalIs}
                onClose={() => setModalIs(false)}
                closeAfterTransition
            >
                <Fade in={modalIs}>
                    <Box sx={customStyles}>
                        <Typography id="transition-modal-title" variant="h6" component="h4" style={{ fontFamily: 'Roboto' }}>
                            Eliminar Beneficiario
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 1 }} style={{ fontFamily: 'Roboto', fontSize: '0.6875 rem' }}>
                            ¿Esta seguro que desea eliminar beneficiario?
                        </Typography>
                        <div
                            className="contenedorBotones"
                            style={{
                                spacing: 9,
                                display: "flex",
                                flexDirection: "row",
                                margin: 13,
                                position: "relative",
                            }}
                        >
                            <Stack spacing={1} direction="row" alignItems={'flex-end'}>
                                <Button
                                    style={{ borderRadius: 20, textTransform: "capitalize" }}
                                    size="small"
                                    color="secondary"
                                    variant="outlined"
                                    type="submit"
                                    onClick={handleCancelModal}
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    style={{ borderRadius: 20, textTransform: "capitalize" }}
                                    size="small"
                                    color="secondary"
                                    variant="contained"
                                    type="submit"

                                    onClick={handleDeleteBeneficiary}
                                >
                                    Confirmar
                                </Button>
                            </Stack>
                        </div>
                    </Box>
                </Fade>
            </Modal>
        </Layout>
    );
};

export default SuccessBenData;